import React from 'react'
import moment from 'moment'
import classNames from 'classnames'

import styles from './PageUpdated.css'
import newStyles from './PageUpdatedNew.css'
import RefreshIcon from 'static/images/icons/refresh.svg'
import { getTimeFormat, getRegion } from '../../constants'
import { FormattedMessage } from 'react-intl'

export const PageUpdated = props => {
  const {
    isLoading,
    handleOnClick,
    lastUpdated,
    hasTabs,
    className,
    me,
    useNewStyles = false
  } = props

  // if useNewStyles value is true then component will use new styles [KPW-2484]
  const currentStyles = useNewStyles ? newStyles : styles

  const getTimeFormatPlaceholder = () => (getRegion() === 'us' ? '\u2013\u2013:\u2013\u2013 \u2013\u2013' : '\u2013\u2013:\u2013\u2013')
  const pageUpdatedClasses = classNames({
    [!useNewStyles
      ? currentStyles.pageUpdatedHigh
      : newStyles.pageUpdatedHighOld]: !hasTabs,
    [!useNewStyles
      ? currentStyles.pageUpdatedLow
      : newStyles.pageUpdatedLowOld]: hasTabs,
    [className]: className !== undefined,
  })
  return (
    <div className={pageUpdatedClasses}>
      <p><FormattedMessage id="information.Last_Refreshed" /></p>
      <div className={currentStyles.updatedTime}>
        <span>
          {lastUpdated
            ? moment(lastUpdated).format(getTimeFormat(me))
            : getTimeFormatPlaceholder()
          }
        </span>
      </div>
      <button
        className={currentStyles.refreshPage}
        onClick={!isLoading ? handleOnClick : undefined}
        disabled={isLoading}
      >
        {!isLoading ?
          <RefreshIcon />
          :
          <div
            className={currentStyles.spinningRefresh}
          >
            <RefreshIcon />
          </div>
        }
      </button>
    </div>
  )
}

export default PageUpdated



// WEBPACK FOOTER //
// ./src/legacy/components/PageUpdated/PageUpdated.jsx